
























































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ReturnDelivery extends Vue {
  @Prop() public checkedDeliveryItems:Array<Common.DeliveryItem>; 
  @Prop() public parentDelivery:Common.Delivery;
  @Prop() public salesPurchaseFlag:Common.SalesPurchaseFlags;
  @Prop() public parentMainList:Components.ListView;
  public isSales:boolean = false;

  // 返品ダイアログ用プロパティ
  public rdCaptions = new Array();
  public rdWidths = new Array();
  public rdSlots = new Array();
  public rdGridConfig:Common.GridConfiguration = null;
  public rdPic: string = '';
  public rdReturnDate: Date = new Date().getCalendarDate();
  public rdWorkflowId:number = 0;
  public rdInvoiceWorkflowId:number = 0;
  // ワークフロー処理用プロパティ
  public rdButtonNames: Array<string> = null;
  public rdButtonIndexIdArray: Array<{index:number,actionId:number}> =null;
  public tenantSettings: Common.TenantSettings = null;
  public usedTypes = Common.UsedTypes;  

  // 返品処理ダイアログを表示
  public mounted() {
  this.tenantSettings = this.$api.tenantSettings;
  if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) this.salesMounted();
  else this.purchaseMounted();
  }

  public purchaseMounted(){
    let tenantSettings: Common.TenantSettings = this.$api.tenantSettings;
    this.isSales = false;

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
      this.$api.modal.show('', '返品の入荷明細が選択されています。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.deliveryFlag == Common.DeliveryFlags.Direct).length > 0){
      this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
      return;
    }
    // 親伝票が指定されている場合、1伝票中の明細に対する返品なためチェック不要
    if(!this.parentDelivery){
      if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
        this.$api.modal.show('', '部門の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
        this.$api.modal.show('', '仕入先の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
        this.$api.modal.show('', '倉庫の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.projectItemNo != this.checkedDeliveryItems[0].projectItemNo).length > 0){
        this.$api.modal.show('', '案件の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }      
    }else{
      // 親伝票が指定されている場合そちらで直送の判定を行う（明細側のdeliveryFlagは値が設定されない
      if(this.parentDelivery.deliveryFlag == Common.DeliveryFlags.Direct){
        this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
        return;
      }
    }

    // 明細の予備項目表示の可変対応

    this.rdGridConfig = new Common.GridConfiguration([],0,'col');
    this.rdGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('返品数量', 150),
      new Common.GridItemConfiguration('調整数量', 150),
    );
    this.rdGridConfig.setGridItems(...tenantSettings.GetGridItems(true,true,true,false,false));
    this.rdCaptions =this.rdGridConfig.gridCaptions;
    this.rdWidths = this.rdGridConfig.gridWidths;
    this.rdSlots = this.rdGridConfig.gridSlots;

    // プロパティの初期化
    this.rdPic = this.$api.auth.userId;
    this.rdReturnDate = new Date().getCalendarDate();
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseDelivery');
    this.rdInvoiceWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseInvoice');
    this.onReturnDeliveryChangeWorkflow();

    // ダイアログの表示
    var items = this.checkedDeliveryItems.map(item => item.copy());
    (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public salesMounted(){
    let tenantSettings: Common.TenantSettings = this.$api.tenantSettings;
    this.isSales = true;

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
      this.$api.modal.show('', '返品の請求明細が選択されています。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.deliveryFlag == Common.DeliveryFlags.Direct).length > 0){
      this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
      return;
    }
    // 親伝票が指定されている場合、1伝票中の明細に対する返品なためチェック不要
    if(!this.parentDelivery){
      if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
        this.$api.modal.show('', '部門の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
        this.$api.modal.show('', '得意先の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
        this.$api.modal.show('', '倉庫の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.projectItemNo != this.checkedDeliveryItems[0].projectItemNo).length > 0){
        this.$api.modal.show('', '案件の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }      
    }else{
      // 親伝票が指定されている場合そちらで直送の判定を行う（明細側のdeliveryFlagは値が設定されない
      if(this.parentDelivery.deliveryFlag == Common.DeliveryFlags.Direct){
        this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
        return;
      }
    }

    // 明細の予備項目表示の可変対応
    this.rdGridConfig = new Common.GridConfiguration([],0, 'col');
    this.rdGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('返品数量', 150),
      new Common.GridItemConfiguration('調整数量', 150)
    );
    this.rdGridConfig.setGridItems(...tenantSettings.GetGridItems(true,true,true,false,false));
    this.rdCaptions =this.rdGridConfig.gridCaptions;
    this.rdWidths = this.rdGridConfig.gridWidths;
    this.rdSlots = this.rdGridConfig.gridSlots;
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_salesDelivery');
    this.onReturnDeliveryChangeWorkflow();

    // プロパティの初期化
    if(this.parentDelivery) this.rdPic = this.parentDelivery.counterpart.salesPerson ? this.parentDelivery.counterpart.salesPerson : this.$api.auth.userId;
    else this.rdPic = this.checkedDeliveryItems[0].delivery.counterpart.salesPerson ? this.checkedDeliveryItems[0].delivery.counterpart.salesPerson : this.$api.auth.userId;

    this.rdReturnDate = new Date().getCalendarDate();

    // ダイアログの表示
    var items = this.checkedDeliveryItems.map(item => (item as Common.SalesDeliveryItem).copyReturn());
    (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public onReturnDeliveryChangeWorkflow(){
    this.rdButtonNames=new Array();
    this.rdButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    if(this.isSales)this.rdButtonNames.push("出荷保存");
    else this.rdButtonNames.push("入荷保存");
    if(this.rdWorkflowId!=0)
    {
      var actions = this.isSales ? this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.rdWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting) : this.$api.perms.getWorkflowActionsHasPermission('purchaseDelivery', this.rdWorkflowId, Common.DeliveryStatus.PurchaseDeliverySaving);
      actions.forEach(action => {
        this.rdButtonNames.push(action.actionName);
        this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

    // ダイアログの表示
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  // 返品処理の実行
  public async submitReturnDelivery(list: Array<Common.DeliveryItem>, index:number) {
   // クエリの設定
    var query = new Common.ReturnDeliveryQuery();
    query.pic = this.rdPic;
    query.deliveryDate = this.rdReturnDate;
    query.workflowId = this.rdWorkflowId;
    query.invoiceWorkflowId = this.rdInvoiceWorkflowId;
    query.deliveryItems = new Array();
    query.baseItems = this.checkedDeliveryItems;
    query.actionId = this.rdButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    if(this.isSales) list.forEach(item =>{
        let returnItem = (item as Common.SalesDeliveryItem).copyReturn();
        if(this.parentDelivery){
          // Deliveryから起動した場合必要な情報がDeliveryItemにないため設定
          returnItem.segment = this.parentDelivery.segment;
          returnItem.warehouse = this.parentDelivery.warehouse;
          returnItem.delivery = this.parentDelivery;
        }
        returnItem.quantity *= -1;
        returnItem.adjustmentQuantity *= -1;
        query.deliveryItems.push(returnItem);
      });
      else list.forEach(item =>{
        let returnItem = item.copy();
        if(this.parentDelivery){
          // Deliveryから起動した場合必要な情報がDeliveryItemにないため設定
          returnItem.segment = this.parentDelivery.segment;
          returnItem.warehouse = this.parentDelivery.warehouse;
          returnItem.delivery = this.parentDelivery;
        }
        returnItem.quantity *= -1;
        returnItem.adjustmentQuantity *= -1;
        query.deliveryItems.push(returnItem);
      });

    (this.$refs.returnDeliveryDialog as Components.ListDialog).closeDialog();

    return this.$api.execute(query,true).then(res => {
      //何も更新されないが..
      //  (this.$refs.mainList as Components.ListView).reload();
      var returnDelivery = res as Common.Delivery;
      this.parentMainList.reload();
      if(this.isSales)this.$api.modal.show('処理結果','以下の出荷伝票が作成されました。',true,null,[new Common.ModalLink(returnDelivery.deliveryNo, String.format('/sales/SalesDelivery?deliveryNo={0}',returnDelivery.deliveryNo))]);
      else this.$api.modal.show('処理結果','以下の入荷伝票が作成されました。',true,null,[new Common.ModalLink(returnDelivery.deliveryNo, String.format('/purchase/PurchaseDelivery?deliveryNo={0}',returnDelivery.deliveryNo))]);
      return true;
    }).catch(()=>{return false;});    

  }

}
